export type PillButtonVariant = 'cta' | 'soft';

export type PillButtonOptions = {
  href?: string;
  variant?: PillButtonVariant;
  large?: boolean;
  small?: boolean;
  class?: string;
  id?: string;
  ariaLabel?: string;
  disabled?: boolean;
  onClick?: () => void;
};

function pillButtonClasses(opts: PillButtonOptions): string {
  const parts = ['btn-pill'];
  parts.push(opts.variant === 'soft' ? 'btn-pill--soft' : 'btn-pill--cta');
  if (opts.large) parts.push('btn-pill--lg');
  if (opts.small) parts.push('btn-pill--sm');
  if (opts.class) parts.push(opts.class);
  return parts.join(' ');
}

function pillButtonInnerHtml(label: string): string {
  return `
    <span class="btn-pill-bg" aria-hidden="true">
      <span class="btn-pill-bg-layers">
        <span class="btn-pill-bg-layer btn-pill-bg-layer-1 -deep"></span>
        <span class="btn-pill-bg-layer btn-pill-bg-layer-2 -mid"></span>
        <span class="btn-pill-bg-layer btn-pill-bg-layer-3 -base"></span>
      </span>
    </span>
    <span class="btn-pill-inner">
      <span class="btn-pill-inner-static">${label}</span>
      <span class="btn-pill-inner-hover" aria-hidden="true">${label}</span>
    </span>`;
}

/** HTML d’un lien bouton pill (pour templates innerHTML). */
export function pillButtonHtml(label: string, opts: PillButtonOptions & { href: string }): string {
  return `<a href="${opts.href}" class="${pillButtonClasses(opts)}">${pillButtonInnerHtml(label)}</a>`;
}

/** Bouton pill en élément DOM (lien ou &lt;button&gt;). */
export function createPillButton(label: string, opts: PillButtonOptions = {}): HTMLElement {
  const node = opts.href ? document.createElement('a') : document.createElement('button');
  node.className = pillButtonClasses(opts);
  if (node instanceof HTMLAnchorElement && opts.href) {
    node.href = opts.href;
    node.addEventListener('click', (e) => {
      e.preventDefault();
      window.location.hash = opts.href!.replace(/^#/, '');
      opts.onClick?.();
    });
  } else if (node instanceof HTMLButtonElement) {
    node.type = 'button';
    if (opts.id) node.id = opts.id;
    if (opts.ariaLabel) node.setAttribute('aria-label', opts.ariaLabel);
    if (opts.disabled) node.disabled = true;
    if (opts.onClick) node.addEventListener('click', opts.onClick);
  }
  node.innerHTML = pillButtonInnerHtml(label);
  return node;
}
